// src/components/EmployeeDashboard.js
import React, { useEffect, useState } from "react";
import { getCurrentEmployee } from "../services/EmployeeService";
import "../css/EmployeeDashboard.css";
import "../css/AdminDashboard.css";
import EmployeeNavbar from "../components/EmployeeNavbar";
import "../css/myestare.css";
import "../css/SupportRequest.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { getRegisteredContactRequests, getFile,getUnregisteredContactRequests,getAllContactRequests,updateRequestStatus  ,getRequestCountByStatus ,getTicketMessages, sendTicketMessage} from "../services/supportService";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Button,
  Divider,
} from "@mui/material";

const EmployeeDashboard = () => {
  const [employee, setEmployee] = useState(null);

  useEffect(() => {
    getCurrentEmployee()
      .then((res) => {
        setEmployee(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch employee:", err);
      });
  }, []);
const [showDetailsModal, setShowDetailsModal] = useState(false);
const [selectedTicket, setSelectedTicket] = useState(null);
const [loading, setLoading] = useState(false);
const [showMessageModal, setShowMessageModal] = useState(false);
const [messageHistory, setMessageHistory] = useState([]);
const [newMessage, setNewMessage] = useState("");
const handleOpenMessages = async (ticketId) => {
  try {
    const res = await getTicketMessages(ticketId); // define this service
    setMessageHistory(res);
    setShowMessageModal(true);
  } catch (err) {
    toast.error("Failed to load messages.");
  }
};
const normalizeStatus = (status) => {
  return status?.toLowerCase().replace("_", "-");
};

const handleSendMessage = async () => {
  if (!newMessage.trim()) return;

  try {
    await sendTicketMessage(selectedTicket.id, {
      content: newMessage,
      sender: "EMPLOYEE",
    });
    const updated = await getTicketMessages(selectedTicket.id);
    setMessageHistory(updated);
    setNewMessage("");
  } catch (err) {
    toast.error("Failed to send message.");
  }
};

const downloadFile = async (ticketId, fileName) => {
  try {
    const response = await getFile(ticketId,fileName);
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href
  = downloadUrl;
    link.download = fileName || 'attachment';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
  return (
    <>
    <EmployeeNavbar />
    <div style={{ marginTop: "4rem" }}></div>  

    <div className="employee-dashboard">
      <h2>Welcome, {employee?.firstName} {employee?.lastName}</h2>
      <h3>Assigned Tickets</h3>

{Array.isArray(employee?.assignedTickets) && employee.assignedTickets.length > 0 ? (
  <div className="scrollable-ticket-section">
    <div className="propCard1">
      <div className="propCard-card1">
        {employee.assignedTickets.map((ticket) => (
          <div className="propCard-card-body" key={ticket.id}>
            <div className="propCard_card_status">
              <p className="propCard-card-text">
              ID: <strong>{ticket.id}</strong>
            </p>
             <p className={`propCard_card_status_text ${normalizeStatus(ticket.status)}`}>
                {{
                  'in-progress': 'In Progress',
                  'solved': 'Solved',
                  'open': 'Open',
                  'reopen': 'Reopen',
                  'closed': 'Closed',
                }[normalizeStatus(ticket.status)] || ticket.status}
              </p>

            </div>

            <div className="propCard-card-title">
              <h5 className="card_subject">{ticket.subject}</h5>
            </div>

            <p className="propCard-card-text">
              Submitted on: {new Date(ticket.createdDate).toLocaleString()}
            </p>

            

            <div className="propCard-btn" style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => {
                setSelectedTicket(ticket);
                setShowDetailsModal(true);
              }}
            >
              Info
            </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
) : (
  <p>No tickets assigned yet.</p>
)}

    </div>
    <Modal open={showDetailsModal} onClose={() => setShowDetailsModal(false)}>
  <Box className="ticket_modal_box">
    {selectedTicket && (
      <>
        <div className="modal_header">
          <Typography variant="h6">Ticket Details</Typography>
          <CloseIcon
            onClick={() => setShowDetailsModal(false)}
            className="modal_close_icon"
            style={{ cursor: "pointer", float: "right" }}
          />
        </div>

        <div className="ticket_details_body">
          <div className="ticket_sections1">
            <div className="ticket_left_section1">
              <p><strong>ID:</strong> {selectedTicket.id}</p>
              <p><strong>Email:</strong> {selectedTicket.user?.email || selectedTicket.email}</p>
              <p><strong>Subject:</strong> {selectedTicket.subject}</p>
              <p><strong>Message:</strong> {selectedTicket.message}</p>
              {selectedTicket.fileNames && selectedTicket.fileNames.length > 0 && (
                <div>
                  <p><strong>Uploaded Files:</strong></p>
                  <ul>
                    {selectedTicket.fileNames.map((fileName, index) => (
                      <li key={index}>
                        <span
                          onClick={() => downloadFile(selectedTicket.id, fileName)}
                          style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                        >
                          {fileName}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="ticket_right_section1">
              <p><strong>Submitted on:</strong> {new Date(selectedTicket.createdDate).toLocaleString()}</p>
              {selectedTicket.user && (
                <p><strong>Solved?</strong> {
                  selectedTicket.userConfirmedResolved === true
                    ? 'YES'
                    : selectedTicket.userConfirmedResolved === false
                      ? 'NO'
                      : 'Not confirmed'
                }</p>
              )}

              <select
                value={selectedTicket.status}
                className={`status_dropdown ${
                  selectedTicket.status === "OPEN"
                    ? "open_tab1"
                    : selectedTicket.status === "IN_PROGRESS"
                    ? "pending_tab1"
                    : selectedTicket.status === "REOPEN"
                    ? "reopened_tab1"
                    : selectedTicket.status === "SOLVED"
                    ? "rejected_tab1"
                    : selectedTicket.status === "CLOSED"
                    ? "closed_tab1"
                    : ""
                }`}
                onChange={async (e) => {
                  const newStatus = e.target.value;
                  const prevStatus = selectedTicket.status;

                  const allowedTransitions = {
                    OPEN: ["IN_PROGRESS"],
                    IN_PROGRESS: ["SOLVED"],
                    REOPEN: ["SOLVED"],
                    SOLVED: ["CLOSED"],
                  };

                  if (!allowedTransitions[prevStatus]?.includes(newStatus)) {
                    toast.warn(`Cannot move from ${prevStatus} to ${newStatus}`);
                    return;
                  }

                  setLoading(true);
                  try {
                    await updateRequestStatus(selectedTicket.id, newStatus);
                    toast.success(`Status changed from ${prevStatus} to ${newStatus}`);
                    const updated = await getCurrentEmployee();
                    setEmployee(updated.data);
                    setShowDetailsModal(false);
                  } catch (err) {
                    toast.error("Failed to update status.");
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                <option value={selectedTicket.status} disabled>
                  {selectedTicket.status.replace("_", " ")}
                </option>
                {(() => {
                  const allowedTransitions = {
                    OPEN: ["IN_PROGRESS"],
                    IN_PROGRESS: ["SOLVED"],
                    REOPEN: ["SOLVED"],
                    SOLVED: ["CLOSED"],
                  };
                  return allowedTransitions[selectedTicket.status]?.map((status) => (
                    <option key={status} value={status}>
                      {status.replace("_", " ")}
                    </option>
                  ));
                })()}
              </select>
            {selectedTicket.user && (
              <button
                onClick={() => handleOpenMessages(selectedTicket.id)}
                className="message_button"
              >
                MESSAGE
              </button>
            )}
            </div>
          </div>
        </div>
      </>
    )}
  </Box>
</Modal>
<Dialog open={showMessageModal} onClose={() => setShowMessageModal(false)} fullWidth maxWidth="sm">
  <DialogTitle>Messages</DialogTitle>
  <DialogContent dividers>
    <Box
      sx={{
        maxHeight: "300px",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        paddingRight: 1,
      }}
    >
      {messageHistory.length === 0 ? (
        <Typography>No messages yet.</Typography>
      ) : (
        messageHistory.map((msg, idx) => (
          <Box
            key={idx}
            sx={{
              alignSelf: msg.sender === "USER" ? "flex-start" : "flex-end",
              backgroundColor: msg.sender === "USER" ? "#e2f0ff" : "#dcf8c6",
              borderRadius: 2,
              padding: 1,
              maxWidth: "75%",
            }}
          >
            <Typography variant="body2">{msg.content}</Typography>
            <Typography variant="caption" color="textSecondary">
              {msg.sender} | {new Date(msg.timestamp).toLocaleString()}
            </Typography>
          </Box>
        ))
      )}
    </Box>
  </DialogContent>

  <Divider />

  <DialogActions sx={{ flexDirection: "column", alignItems: "stretch", gap: 1 }}>
    <TextField
      multiline
      minRows={2}
      placeholder="Type a message..."
      fullWidth
      value={newMessage}
      onChange={(e) => setNewMessage(e.target.value)}
    />
    <Box display="flex" justifyContent="flex-end" gap={1}>
      <Button variant="contained" onClick={handleSendMessage}>
        Send
      </Button>
      <Button
        variant="outlined"
        onClick={() => {
          setShowMessageModal(false);
          setNewMessage("");
          setMessageHistory([]);
        }}
      >
        Close
      </Button>
    </Box>
  </DialogActions>
</Dialog>


</>
  );
};
export default EmployeeDashboard;
